import axios from 'axios'
import { API_ROOT_URL, PAGESIZE, BASE_COIN_SYMBOL } from './constants/config'
const client = axios.create()
client.defaults.baseURL = API_ROOT_URL
client.defaults.headers.post['Content-Type'] = 'application/json'
client.defaults.headers.post['Accept'] = 'application/json'
let token = null

client.interceptors.request.use(config => {
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => {
  return Promise.reject(err)
})
const responseData = res => res.data

const requests = {
  del: url => {
    return client.delete(url).then(responseData)
  },
  get: url =>
    client.get(url).then(responseData),
  put: (url, body) =>
    client.put(url, body).then(responseData),
  post: (url, body) =>
    client.post(url, body).then(responseData)
}

const Auth = {
  current: () =>
    requests.get('/users'),
  register: (firstname, lastname, phone, email, password, referrer, notify) =>
    requests.post('/users', JSON.stringify({ firstname, lastname, phone, email, password, referrer, notify })),
  login: (email, password) =>
    requests.post('/users/login', JSON.stringify({ email, password })),
  getPinCode: (mobile, type, userkey) =>
    requests.post(`/users/pincode/get`, JSON.stringify({ mobile, type, userkey })),
  verifyPinCode: (userKey, code, type) =>
    requests.post(`/users/${userKey}/pincode/verify`, JSON.stringify({ code, type })),
  verifyUserPin: (token, userKey, pin) => {
    const instance = axios.create({
      baseURL: API_ROOT_URL
    });
    instance.defaults.headers.post['Content-Type'] = 'application/json';
    instance.defaults.headers.post['Accept'] = 'application/json';
    instance.defaults.headers.Authorization = `Bearer ${token}`;
    return instance.post(`/users/${userKey}/pin/verify`, JSON.stringify({ pin })).then(responseData)
  },
};

const Common = {
  getBaseSymbolAccountDetail: (symbol) => requests.get(`/accounts/${symbol}/detail`),
  getTransactions: (merchantAccountAddress) => requests.get(`/accounts/prime/${merchantAccountAddress}`),
  getTransaction: (key) => requests.get(`/coin/transaction/${key}`),
}
const Categories = {
  getCategories: (userkey) =>
    requests.get(`/categories/user/${userkey}`),
  getDetail: (key) =>
    requests.get(`/categories/${key}`),
  addCategory: (name) =>
    requests.post(`/categories`, { name }),
  updateCategory: (key, name) =>
    requests.put(`/categories/${key}`, { name }),
  deleteCategory: (key) => requests.del(`/categories/${key}`),
  getCategoryProducts: (key) =>
    requests.get(`/category/${key}/products`),
  getCategoryLogs: (key) =>
    requests.get(`/category/${key}/logs`),
}
const Products = {
  getProducts: (userkey) =>
    requests.get(`/products/user/${userkey}`),
  getDetail: (key) =>
    requests.get(`/products/${key}`),
  addProduct: (name, price, currency, category) =>
    requests.post(`/products`, { name, price, currency, category }),
  updateProduct: (key, name, price, currency, category) =>
    requests.put(`/products/${key}`, { name, price, currency, category }),
  deleteProduct: (key) => requests.del(`/products/${key}`),
  getProductLogs: (key) =>
    requests.get(`/product/${key}/logs`),
}
export default {
  Common,
  Auth,
  Categories,
  Products,
  setToken: _token => { token = _token }
}
